export default __webpack_public_path__ + "static/soehne-mono-web-buch-kursiv-9b5fe991742236965a474c261b342275.woff";